import axios from "axios";
import store from "../store/store";
import { logoutUser } from "../redux/auth/actions";
import { API_HOST, APP_CONST } from "../config/const";

export const userToken = () => localStorage.getItem("token");

const getHeaders = () => {
  let headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };

  if (userToken() !== null) {
    headers["Authorization"] = userToken();
  }

  if (process.env.NODE_ENV === APP_CONST.ENVIRONMENTS.DEVELOPMENT) {
    headers["refererLocal"] = window.location.host;
  }
  return headers;
};

export const axiosService = axios.create({
  baseURL: API_HOST,
  headers: getHeaders(),
});

axiosService.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error.response.status === 401 &&
      error.response.data.message === "Unauthorized action." &&
      userToken()
    ) {
      store.dispatch(logoutUser());
    }
    return Promise.reject(error);
  }
);

/**
 *
 * @param token
 */
export const setUserToken = (token) => {
  if (token) {
    axiosService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    axiosService.defaults.headers.common["Authorization"] = token;
  } else {
    axiosService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  }
};

export const removeUserToken = () => {
  delete axiosService.defaults.headers.common["Authorization"];
};

export const AxiosApiHelper = async ({ method, url, headers }) => {
  return axiosService
    .request({
      method: method || "get",
      url,
      headers,
    })
    .then((res) => {
      return res?.data.data;
    })
    .catch((error) => {
      console.log("Errorrrr", error);
      return error.response.data;
    });
};
